import { makeStyles } from '@fluentui/react-components';

export const useResponsiveTabListStyles = makeStyles({
    root: {
        width: '100%',
        overflow: 'hidden',
        paddingBotton: '5px',
    },
});
